(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/invite/helpers/invite-handler.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/invite/helpers/invite-handler.js');
'use strict';

const {
  oldInviteToTeamAsync,
  oldGetInvitationInfoAsync,
  inviteToTeamAsync,
  getInvitationInfoAsync
} = svs.arena.service.inviteService;
const {
  submitInviteDeposit
} = svs.arena.shared.deposit.doDeposit;
const handleInviteError = svs.arena.pages.invite.handleInviteError;
const constants = svs.arena.constants;
const routes = constants.routes;
const {
  showConfirmInviteDialog,
  showWelcomeInviteDialog,
  showInviteErrorDialog,
  showUnavailableInviteDialog
} = svs.arena.pages.invite.dialogs;
const handleInvite = async (params, history) => {
  const invitationId = params === null || params === void 0 ? void 0 : params.invitationId;
  const isCorrectInviteId = invitationId && (invitationId === null || invitationId === void 0 ? void 0 : invitationId.match(/^[a-z0-9-]+$/i)) && (invitationId === null || invitationId === void 0 ? void 0 : invitationId.length) === 36;
  const isCorrectOldinvitationId = invitationId && !isNaN(invitationId) && (invitationId === null || invitationId === void 0 ? void 0 : invitationId.length) === 13;
  svs.arena.logger.debug('**** handleInvite: params, isCorrectInviteId, isCorrectOldinvitationId: ', params, isCorrectInviteId, isCorrectOldinvitationId);
  const navigateToTeamsHomePage = () => {
    history.push("".concat(routes.HOME));
  };
  const handleInvite = async function (teamId, initialDeposit) {
    let syndicateName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'laget';
    const isAcceptedInvite = await showConfirmInviteDialog(syndicateName);
    if (isAcceptedInvite) {
      let errorCode;
      if (isCorrectOldinvitationId) {
        errorCode = await oldInviteToTeamAsync(invitationId);
      } else {
        errorCode = await inviteToTeamAsync(invitationId);
      }
      if (errorCode) {
        handleInviteError(errorCode);
        navigateToTeamsHomePage();
      } else {
        const track = {
          category: 'spela-tillsammans',
          action: 'invitation_from_link',
          opt_label: 'join_team'
        };
        svs.components.analytics.trackEvent(track);
        let depositData = {};
        await showWelcomeInviteDialog(syndicateName);
        if (initialDeposit && parseInt(initialDeposit, 10) > 0) {
          depositData = await submitInviteDeposit(initialDeposit, teamId);
        }
        const mb = encodeURIComponent(depositData.memberBalance);
        const tb = encodeURIComponent(depositData.syndicateBalance);
        const pa = encodeURIComponent(depositData.playableAmount);
        let search = "?teamId=".concat(teamId);
        if (Object.keys(depositData).length > 0) {
          search += "&mb=".concat(mb, "&tb=").concat(tb, "&pa=").concat(pa);
        }

        history.push({
          pathname: routes.TEAMS_WAIT_FOR_BACKEND,
          search
        });
      }
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: 'invitation_from_link',
        opt_label: 'no_thanks'
      };
      svs.components.analytics.trackEvent(track, navigateToTeamsHomePage);
    }
  };
  if (isCorrectInviteId || isCorrectOldinvitationId) {
    try {
      let getInvitationInfoData;
      if (isCorrectInviteId) {
        getInvitationInfoData = await getInvitationInfoAsync(invitationId);
      } else {
        getInvitationInfoData = await oldGetInvitationInfoAsync(invitationId);
      }
      const {
        error,
        teamId,
        initialDeposit,
        syndicateName
      } = getInvitationInfoData;
      if (error) {
        svs.arena.logger.info('Error when trying to get invite', error);
        showInviteErrorDialog();
        navigateToTeamsHomePage();
      } else if (!teamId && !initialDeposit) {
        showUnavailableInviteDialog();
        navigateToTeamsHomePage();
      } else {
        handleInvite(teamId, initialDeposit, syndicateName);
      }
    } catch (e) {
      svs.arena.logger.warn("Error when handling invite", e);
      showInviteErrorDialog();
      navigateToTeamsHomePage();
    }
  } else {
    svs.arena.logger.info('Could not find invitationId');
    showUnavailableInviteDialog();
    navigateToTeamsHomePage();
  }
};
svs.arena.pages.invite.handleInvite = handleInvite;

 })(window);